import { render } from "./UserIndex.vue?vue&type=template&id=4acf7ad7"
import script from "./UserIndex.vue?vue&type=script&lang=js"
export * from "./UserIndex.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__